import loadable from '@loadable/component';

export const CreateOrgPageContainerLoadable = loadable(
  () => import('./CreateOrgPageContainer'),
  { resolveComponent: (module) => module.CreateOrgPageContainer },
);
